<template>
  <v-dialog
    v-model="modal"
    :width="width"
    :max-width="maxWidth"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    v-bind="$attrs"
  >
    <slot name="outer-body">
      <v-card>
        <v-card-title class="justify-space-between px-4">
          <span :class="titleClass">{{ title }}</span>
          <slot name="header-right"></slot>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="cardTextClass">
          <slot name="inner-body">
            <v-container>
              <v-row>
                <v-col cols="12">
                  SLOT
                </v-col>
              </v-row>
            </v-container>
          </slot>
        </v-card-text>
      </v-card>
    </slot>
  </v-dialog>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Title'
    },
    width: {
      default: '100%'
    },
    maxWidth: {
      default: '500px'
    },
    cardTextClass: {
      type: String,
      default: ''
    }
  },
  watch: {
    modal(value) {
      this.$emit('modalStatus', value);
    }
  },
  computed: {
    titleClass() {
      return this.$vuetify.breakpoint.xs ? 'title' : 'headline';
    }
  }
}
</script>

<style>

</style>